(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/poker-react/assets/javascripts/poker-router.js') >= 0) return;  svs.modules.push('/modules/poker-react/assets/javascripts/poker-router.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _ReactRouterDOM = ReactRouterDOM,
  Router = _ReactRouterDOM.BrowserRouter,
  Route = _ReactRouterDOM.Route,
  Switch = _ReactRouterDOM.Switch;
const _React = React,
  useEffect = _React.useEffect;
const _svs$components$lbUti = svs.components.lbUtils.setMetaTags,
  setMetaTags = _svs$components$lbUti.setMetaTags,
  setHeaderImageAltText = _svs$components$lbUti.setHeaderImageAltText;
const _svs$poker_react = svs.poker_react,
  _svs$poker_react$rout = _svs$poker_react.routeComponents,
  RouteNews = _svs$poker_react$rout.RouteNews,
  RouteWidget = _svs$poker_react$rout.RouteWidget,
  RouteRanking = _svs$poker_react$rout.RouteRanking,
  PokerNavMenu = _svs$poker_react.components.PokerNavMenu;
const _svs$components$lbUi$ = svs.components.lbUi.modal,
  ModalHidden = _svs$components$lbUi$.ModalHidden,
  ModalPortal = _svs$components$lbUi$.ModalPortal;
const CampaignFlerp = svs.components.lbUi.campaignFlerp.CampaignFlerp;
const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
const _svs$poker_react$comp = svs.poker_react.components.common.constants,
  BrowserStorageConstants = _svs$poker_react$comp.BrowserStorageConstants,
  MenuTabTypes = _svs$poker_react$comp.MenuTabTypes;
const BrowserStorage = svs.components.Storage.browser;
const launchWebClient = svs.poker_react.components.common.helpers.launchWebClient;
const getRouteComponent = tabType => {
  switch (tabType) {
    case MenuTabTypes.News:
      return RouteNews;
    case MenuTabTypes.Ranking:
      return RouteRanking;
    default:
      return RouteWidget;
  }
};
const PokerRouter = () => {
  const routes = svs.poker_react.data.tabsConfig;

  useEffect(() => {
    if (!isLoggedIn) {
      BrowserStorage.remove(BrowserStorageConstants.OpenWebClientKey, BrowserStorageConstants.Domain);
      return;
    }
    BrowserStorage.get(BrowserStorageConstants.OpenWebClientKey, BrowserStorageConstants.Domain, (data, err) => {
      if (!data || err) {
        return;
      }
      if (data.openWebClient) {
        launchWebClient(_objectSpread(_objectSpread({}, data.params), {}, {
          shouldTrackEvent: false
        }));
        BrowserStorage.remove(BrowserStorageConstants.OpenWebClientKey, BrowserStorageConstants.Domain);
      }
    });
  }, []);
  const activeRoutes = routes.filter(route => route.active);
  return React.createElement(Router, {
    basename: svs.core.data.baseUrl
  }, React.createElement(ModalPortal, null, React.createElement(ModalHidden, null, React.createElement("div", {
    className: "poker-react-bg-layer"
  }, React.createElement(CampaignFlerp, null), React.createElement(PokerNavMenu, {
    routes: activeRoutes
  }), React.createElement("main", null, React.createElement(Switch, null, React.createElement(Route, {
    exact: true,
    path: "/",
    render: () => {
      const newsRoute = routes.find(route => route.tabType === MenuTabTypes.News);
      setMetaTags({
        canonicalUrl: newsRoute === null || newsRoute === void 0 ? void 0 : newsRoute.canonicalUrl,
        docTitle: (newsRoute === null || newsRoute === void 0 ? void 0 : newsRoute.metaTitle) || "Poker - ".concat(newsRoute.label),
        metaDesc: (newsRoute === null || newsRoute === void 0 ? void 0 : newsRoute.metaDescription) || "Poker - ".concat(newsRoute === null || newsRoute === void 0 ? void 0 : newsRoute.label)
      });
      setHeaderImageAltText((newsRoute === null || newsRoute === void 0 ? void 0 : newsRoute.logotypeAltText) || "Poker - ".concat(newsRoute === null || newsRoute === void 0 ? void 0 : newsRoute.label));
      return React.createElement(RouteNews, null);
    }
  }), routes.map(route => React.createElement(Route, {
    key: route.path,
    path: "/".concat(route.path),
    render: () => {
      var _route$headerConfig;
      const Component = getRouteComponent(route.tabType);
      setMetaTags({
        canonicalUrl: route === null || route === void 0 ? void 0 : route.canonicalUrl,
        docTitle: (route === null || route === void 0 ? void 0 : route.metaTitle) || "Poker - ".concat(route === null || route === void 0 ? void 0 : route.label),
        metaDesc: (route === null || route === void 0 ? void 0 : route.metaDescription) || "Poker - ".concat(route === null || route === void 0 ? void 0 : route.label)
      });
      setHeaderImageAltText(((_route$headerConfig = route.headerConfig) === null || _route$headerConfig === void 0 ? void 0 : _route$headerConfig.logotypeAltText) || "Poker - ".concat(route === null || route === void 0 ? void 0 : route.label));
      return React.createElement(Component, {
        widgetAreaIndex: route.widgetArea
      });
    }
  }))))), React.createElement("div", {
    className: "poker-react-bg-spotlight"
  }))));
};
setGlobal('svs.poker_react.components.PokerRouter', PokerRouter);

 })(window);